import React, { useLayoutEffect } from "react";
import { useMedia } from "use-media";
import { connect, useStore } from "react-redux";
import logo from "../../../resources/icons/logo_reservations.svg";
import { Label } from "../../atoms/RTCC/label";
import { useHistory } from "react-router-dom";
import User from "../../../User.js";

import './../../../resources/RTCC/css/header/header.css';

const TopHeaderContainer = (props) => {
    const { login, clearState, setPathSetLoading } = props;
    const isWideTablet = useMedia({ maxWidth: "960px" });
    const history = useHistory();
    const store = useStore();
    const prevScreenInfo = store.getState().prevScreenInfo;
  
    // ページ遷移管理処理
    useLayoutEffect(() => {
      store.dispatch({ type:"PREV_SCREEN_INFO", payload: { prevScreenInfo: {currentPath: history.location.pathname , prevPath: prevScreenInfo.currentPath}} });
      if(setPathSetLoading){
        setPathSetLoading(false);
      }
    },[])

    const onClickBack = () => {
        history.push(props.path);
    }
    const onClickIcon = () => {
        history.push("/reserve/top");
    };
    const onClickLogout = () => {
        User.logout();
        clearState();
        history.push("/reserve/login");
    }
    return (
        <header>
            <div className="headerBaseWrapper">
                <img onClick={onClickIcon} src={logo} className="headerBaseLeftImg" />
                {login && login.userId ? (
                    <div style={styles.headerBaseRightLogout} className="headerBaseRightLogout">
                        <a href="/reserve/login" style={styles.headerLogout} onClick={onClickLogout}>ログアウト</a>
                    </div>
                ) : null
                }
            </div>
            <div className="headerBaseWrapper2" >
                <div className={isWideTablet ? "headerCenterWrapperSp" : "headerCenterWrapper"}>
                    <div className="headerLabelWrapper">
                        <div>
                            {isWideTablet && props.path ?
                                <div style={{ position: "absolute", left: 40, top: "29%", justifyContent: "center" }} onClick={onClickBack}>＜</div>
                                : null}
                            <Label label={props.categoryLabel1} className={isWideTablet ? "LabelStyleSp1" : "LabelStyle1"} />
                            <Label label={props.categoryLabel2} className={isWideTablet ? "LabelStyleSp2" : "LabelStyle2"} />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

const mapStateToProps = (state) => { return { login: state.login }; };
const mapToDispatchToProps = (dispatch) => {
    return {
        clearState: () => {
            dispatch({ type: "CLEAR_STATE" })
        }
    };
}
export default connect(mapStateToProps, mapToDispatchToProps)(TopHeaderContainer);

const styles = {
    linkLabel: {
        cursor: "pointer",
        height: "16px",
    },
    headerBaseRightLogout: {
        float: "right",
        marginTop: "1rem 1rem 0 0",
        letterSpacing: "0.05rem",
        fontWeight: 500,
        height: "16px"
    },
    headerLogout: {
        textDecoration: 'none',
        fontSize: ".7rem",
        textAlign: "center",
        color: "white",
        width: "100%",
    },
}
